import React from "react";
import { Errors, form, Form as AppForm } from "MODULES/shared/components/Forms";
import { Warning } from "MODULES/shared/components";
import { connect } from "react-redux";
import api from "APP_ROOT/api";
import { API_BASE } from "APP_ROOT/constants";
import { change, getFormValues } from "redux-form";
import validate from "MODULES/shared/components/CommercialInvoice/Form/FormSections/validate";
import {
  COMMERCIAL_INVOICE_FORM,
  REPLACE_PDF
} from "MODULES/shared/components/CommercialInvoice/Form/Form";
import { Button } from "react-bootstrap";
import {
  COMMERCIAL_INVOICE,
  SAVE_OR_REPLACE_FORM
} from "MODULES/shared/components/CommercialInvoice/helpers";
import { getAttachments } from "MODULES/shared/actions/attachments";
import resourceTypes from "MODULES/shared/types/resourceTypes";

function SaveWarning(props) {
  return (
    <AppForm {...props}>
      <AppForm.Body>
        <Warning>
          Would you like to replace the previously saved Commercial Invoice?
        </Warning>
      </AppForm.Body>
      <AppForm.Footer>
        {props.submitFailed && <Errors errors={props.errorMessages} />}
        <AppForm.Cancel
          close={() => props.setCurrentForm(COMMERCIAL_INVOICE)}
          editable
        />
        <Button
          type="submit"
          onClick={() => props.setFieldValue(REPLACE_PDF)(false)}
        >
          No
        </Button>
        <Button
          type="submit"
          bsStyle="success"
          onClick={() => props.setFieldValue(REPLACE_PDF)(true)}
        >
          Yes
        </Button>
      </AppForm.Footer>
    </AppForm>
  );
}

export default connect(
  state => ({
    initialValues: getFormValues(COMMERCIAL_INVOICE_FORM)(state)
  }),
  (dispatch, ownProps) => ({
    onSubmit: async data => {
      const { data: invoice } = await api.commercialInvoices.create(data);
      window.location.href = `${API_BASE}/commercial_invoices/${invoice.id}/download_commercial_invoice`;
      ownProps.setCurrentForm(COMMERCIAL_INVOICE);
      ownProps.close();

      if (data.shipment_id) {
        dispatch(getAttachments(data.shipment_id, resourceTypes.shipment));
      }

      if (data.sales_order_id) {
        dispatch(getAttachments(data.sales_order_id, resourceTypes.salesOrder));
      }

      ownProps.resetForm();
    },
    setFieldValue: field => val =>
      dispatch(change(SAVE_OR_REPLACE_FORM, field, val))
  })
)(
  form({
    form: SAVE_OR_REPLACE_FORM,
    validate
  })(SaveWarning)
);



// WEBPACK FOOTER //
// ./app/modules/shared/components/CommercialInvoice/Form/FormSections/SaveWarning.jsx